import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar.tsx';
import Footer from './components/Footer.tsx';
import Home from './pages/Home.tsx';
import About from './pages/About.tsx';
import Catalog from './pages/Catalog.tsx';
import Contact from './pages/Contact.tsx';
import JewelryDetail from './pages/JewelryDetail.tsx';
import CollectionDetail from './pages/CollectionDetail.tsx';
import NotFound from './pages/NotFound.tsx';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/sobre" element={<About />} />
            <Route path="/catalogo" element={<Catalog />} />
            <Route path="/contato" element={<Contact />} />
            <Route path="/joia/:id" element={<JewelryDetail />} />
            <Route path="/colecao/:id" element={<CollectionDetail />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;

